import { colors, Divider, Tab, Tabs } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AuthGuard, ErrorMessage, GenericHeader, LoadingIndicator, Page, RenderGuard, BookingList } from "components";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from "react-router-dom";
import { Student } from "services";
import { ModelsActions } from "store/actions";
import { account_manager } from 'utils/constants';
import useErrorCatcher from "utils/useErrorCatcher";
import useRouter from 'utils/useRouter';
import { Summary, UserMasteryList, UserModuleList } from "./components";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  tabs: {
    marginTop: theme.spacing(3)
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
  content: {
    marginTop: theme.spacing(3)
  }
}));

let mounted = false;

const StudentDetail = props => {
  const { match, history } = props;
  const classes = useStyles();
  const { student_id, tab } = match.params;
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));
  const model = useSelector(state => state.models.student);
  const dispatch = useDispatch();
  const router = useRouter();

  const reload = () => {
    setLoading(true);
    runAsyncBlock(async () => {
      const { model } = await Student.detail(student_id);
      dispatch(ModelsActions.update_model({ student: model }));
    }).finally(() => setLoading(false));

  }

  useEffect(() => {
    reload();
    // eslint-disable-next-line
  }, [student_id]);

  useEffect(() => {
    mounted = true;
    return () => {
      mounted = false;
    }
  }, []);

  const handleTabsChange = (event, value) => {
    history.push(value);
  };

  const tabs = [
    { value: "summary", label: "Summary" },
    { value: "bookings", label: "Bookings" },
    { value: "masteries", label: "Masteries" },
    { value: "modules", label: "Modules" },
  ];

  if (!tab) {
    return <Redirect to={`/students/${student_id}/summary`} />;
  }

  if (!tabs.find(t => t.value === tab)) {
    return <Redirect to="/errors/error-404" />;
  }

  const handleDelete = () => {
    setLoading(true);
    runAsyncBlock(async () => {
      await Student.del(student_id);
      router.history.push('/students');
    }).finally(() => mounted && setLoading(false));
  }

  return (
    <AuthGuard roles={[account_manager]} projects={[]}>
      <Page className={classes.root} title="Student Details" >
        <ErrorMessage message={errorMessage} />
        <LoadingIndicator variant="card" active={loading} />
        <RenderGuard renderIf={!loading && model}>
          {model && <GenericHeader subheader={model.name_en} header="Student" subtitle={model.reference} />}
          <Tabs
            className={classes.tabs}
            onChange={handleTabsChange}
            scrollButtons="auto"
            value={tab}
            variant="scrollable" >
            {tabs.map(tab => <Tab key={tab.value} label={tab.label} value={tab.value} />)}
          </Tabs>
          <Divider className={classes.divider} />
          <div className={classes.content}>
            {tab === "summary" && <Summary reload={reload} handleDelete={handleDelete} />}
            {tab === "bookings" && <BookingList student={model} />}
            {tab === "masteries" && <UserMasteryList />}
            {tab === "modules" && <UserModuleList />}
          </div>
        </RenderGuard>
      </Page>
    </AuthGuard>
  );
};

StudentDetail.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default StudentDetail;
